import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 5.2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 6.4rem;
  }
`;

export const Subtitle = styled.span`
  display: block;
  margin-bottom: 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-bottom: 4rem;
  }
`;

export const Wrapper = styled.div`
  padding-top: 14.5rem;
  margin-bottom: 8rem;
  color: var(--color-text-light);

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-top: 25rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-bottom: 3.5rem;
  }
`;
